import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import { store } from './components/state/app/store';
// import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import {ContextProvider} from "./components/state/ContextProvider";
import { getAnalytics, logEvent } from "firebase/analytics";

// 本番環境のみ計測
if (process.env.NODE_ENV === 'production') {
  const analytics = getAnalytics();
  logEvent(analytics, 'select_content', {
    content_type: 'top',
    content_id: '123',
    items: [{ name: 'access' }]
  });
}

ReactDOM.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
